module.exports = "<app-contact-heading></app-contact-heading>\n<app-footer></app-footer>"